import {useAppSelector} from 'app/store'
import classNames from 'classnames'
import {usePoliciesQuery} from 'features/Policies/usePolicyQuery'
import {usePolicy} from 'hooks'
import {Policy, PolicyRoutesEnum} from 'interfaces'
import {useLocation} from 'react-router'
import {NavLink} from '../LeftNavLink'
import {CanIAccess, PERMISSIONS} from 'rbac'

export function PoliciesLeftNavigation() {
  const {selectedPolicyName} = useAppSelector(rdxSt => rdxSt.policies)
  const location = useLocation<{policyName: string}>()
  const {pathname} = location
  usePoliciesQuery()

  const {isBasePolicyToBeColored} = usePolicy()

  return (
    <div
      className={classNames('flex flex-col items-start pt-3 px-5 h-full', {
        'bg-dope-teal-100': isBasePolicyToBeColored,
      })}
    >
      <NavLink
        pathname={PolicyRoutesEnum.POLICIES_CONTENT}
        first
        current={pathname === PolicyRoutesEnum.POLICIES_CONTENT}
        linkName="Content"
        currentPolicyName={selectedPolicyName}
      />
      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_USERS.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.USERS}
          first
          current={pathname === PolicyRoutesEnum.USERS}
          linkName="Users"
          currentPolicyName={selectedPolicyName}
          classNames={`${
            selectedPolicyName === Policy.BasePolicy ? 'hidden' : 'block'
          }`}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.VIEW_POLICY_CAC.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.CLOUD_APP}
          first
          current={pathname === PolicyRoutesEnum.CLOUD_APP}
          linkName="Cloud App"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.DLP_POLICY_CONFIGURATION.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.DLP}
          current={pathname === PolicyRoutesEnum.DLP}
          linkName="DLP"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>
      <CanIAccess reqPermissions={[PERMISSIONS.POLICY_BYPASS.READ]}>
        <NavLink
          pathname={PolicyRoutesEnum.BYPASS}
          first
          current={pathname === PolicyRoutesEnum.BYPASS}
          linkName="Bypass"
          currentPolicyName={selectedPolicyName}
        />
      </CanIAccess>
    </div>
  )
}
